module.exports = __webpack_public_path__ + "static/Serena_Greco-57586c51901a733f07c93d7282d18c28.png";